import { Box, type BoxProps, Text, Tooltip, Indicator } from '@mantine/core'
import { clsx } from 'clsx'
import Link from 'next/link'
import React from 'react'

import { type Menu } from '../../hooks/useMenus'
import classes from './styles.module.css'

type NavbarItemProps = BoxProps & {
  item: Menu
}

export function NavbarItem({ item }: NavbarItemProps) {
  if (item.omit) {
    return <></>
  }

  const { pathname } = window.location

  const navbarItemClasses = clsx(classes.navbarItem, {
    [classes.navbarItemActive]:
      (pathname === '/' && item.path === '/') ||
      (item.path !== '/' && pathname.startsWith(item.path)),
  })

  return (
    <Tooltip
      label={item.label}
      position='right'
      py='sm'
      px='md'
      radius='xs'
      offset={0}
      arrowSize={8}
      withArrow
    >
      <Link className={navbarItemClasses} href={item.path}>
        <Box className={classes.navbarItemIcon}>
          <Indicator
            disabled={!item.indicator}
            color='orange'
            position='top-end'
            size={8}
          >
            {item.icon}
          </Indicator>
        </Box>
        <Text size='sm' truncate className={classes.navbarItemLabel}>
          {item.label}
        </Text>
      </Link>
    </Tooltip>
  )
}
